import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo_short.png'


const _withScopeId = n => (_pushScopeId("data-v-56c66328"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-title" }
const _hoisted_2 = {
  key: 0,
  class: "df"
}
const _hoisted_3 = { class: "text-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: _normalizeClass(["header-logo", {'header-logo--top': !_ctx.title && !_ctx.subtitle}]),
      src: _imports_0,
      alt: "logo"
    }, null, 2),
    (_ctx.title || _ctx.subtitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", {
              class: _normalizeClass(["title", {'error': _ctx.error}])
            }, _toDisplayString(_ctx.title), 3)
          ]),
          (!!_ctx.subtitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.subtitleLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: _normalizeClass(["sub-title link", {'error': _ctx.error}]),
                      href: _ctx.subtitleLink
                    }, _toDisplayString(_ctx.subtitle), 11, _hoisted_5))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: _normalizeClass(["sub-title text", {'error': _ctx.error}])
                    }, _toDisplayString(_ctx.subtitle), 3))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}